export default [
  {
    path: "/projects/:projectId/experiments/:experimentId/annotations",
    name: "AnnotationOverview",
    component: () => import("@/views/AnnotationOverview.vue"),
  },
];
